
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import ControlDragHandle from './control-drag-handle'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "controldraghandle"
    }}>{`ControlDragHandle`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Controls`}</p>
    <hr />
    <h2 {...{
      "id": "drag--handle"
    }}>{`Drag + handle`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For revealing or altering media or content, either by peripheral input or drag gesture.`}</p>
    <Playground __position={1} __code={'<ControlDragHandle />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlDragHandle
    }} style={{
      height: '8em',
      display: 'flex',
      justifyContent: 'center'
    }} mdxType="Playground">
  <ControlDragHandle mdxType="ControlDragHandle" />
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={2} __code={'<ControlDragHandle disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlDragHandle
    }} style={{
      height: '8em',
      display: 'flex',
      justifyContent: 'center'
    }} mdxType="Playground">
  <ControlDragHandle disabled mdxType="ControlDragHandle" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "drag--handle-inverse"
    }}>{`Drag + handle (inverse)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For revealing or altering media or content, either by peripheral input or drag gesture.`}</p>
    <Playground __position={4} __code={'<ControlDragHandle inverse />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlDragHandle
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em',
      height: '8em',
      display: 'flex',
      justifyContent: 'center'
    }} mdxType="Playground">
    <ControlDragHandle inverse mdxType="ControlDragHandle" />
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={5} __code={'<ControlDragHandle inverse disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlDragHandle
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em',
      height: '8em',
      display: 'flex',
      justifyContent: 'center'
    }} mdxType="Playground">
  <ControlDragHandle inverse disabled mdxType="ControlDragHandle" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "drag--handle-horizontal"
    }}>{`Drag + handle (horizontal)`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`For revealing or altering media or content, either by peripheral input or drag gesture.`}</p>
    <Playground __position={7} __code={'<ControlDragHandle horizontal />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlDragHandle
    }} mdxType="Playground">
    <ControlDragHandle horizontal mdxType="ControlDragHandle" />
    </Playground>
    <Playground __position={8} __code={'<ControlDragHandle horizontal disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlDragHandle
    }} mdxType="Playground">
  <ControlDragHandle horizontal disabled mdxType="ControlDragHandle" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "drag--handle-horizontal-inverse"
    }}>{`Drag + handle (horizontal, inverse)`}</h2>
    <h3 {...{
      "id": "description-3"
    }}>{`Description`}</h3>
    <p>{`For revealing or altering media or content, either by peripheral input or drag gesture.`}</p>
    <Playground __position={10} __code={'<ControlDragHandle inverse horizontal />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlDragHandle
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
    <ControlDragHandle inverse horizontal mdxType="ControlDragHandle" />
    </Playground>
    <Playground __position={11} __code={'<ControlDragHandle horizontal inverse disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlDragHandle
    }} style={{
      backgroundColor: '#333',
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <ControlDragHandle horizontal inverse disabled mdxType="ControlDragHandle" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={ControlDragHandle} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;